module.exports = __webpack_public_path__ + "img/card_sanpaolo_background.81217291.png";